module.exports = __webpack_public_path__ + "static/img/logo.d2174cde.png";